import { render, staticRenderFns } from "./DraftChangeOrders.vue?vue&type=template&id=3b3ea05b"
import script from "./DraftChangeOrders.vue?vue&type=script&lang=js"
export * from "./DraftChangeOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports